module.exports = __webpack_public_path__ + "static/media/Mitel-Logo-RGB.e167e172.jpg";